import React from "react";
import Modal from "react-modal";
import ReceivedGoods from "../../ReceivedGoods/ReceivedGoods";

export function GoodReceivedModal({ isOpen, details, onClose, onServiceNext }) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Set as Out of Warranty"
      className="input-modal"
    >
      <ReceivedGoods
        userDevices={details?.user_device}
        handleCloseModal={onClose}
        serviceNext={onServiceNext}
        ticketId={details?.id}
      />
    </Modal>
  );
}
